import React, { useLayoutEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';
import { HTML_LANG, stripLangPrefix } from '../i18n/config';

// 自前のヘッダーを持つページ。共通ヘッダーを重ねて出さない。
// 言語プレフィックスを除いたパスで判定する。
const SELF_HEADER_ROUTES = ['/business/inbound'];

/**
 * 言語ごとのルートを束ねるレイアウト。
 * 責務は「言語の適用」「html lang属性の設定」「Header/Footerの描画」の3つだけ。
 */
const LangLayout = ({ lang }) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const { rest } = stripLangPrefix(location.pathname);
  const ownHeader = SELF_HEADER_ROUTES.includes(rest);

  // useLayoutEffect はブラウザの描画前に実行されるため、翻訳リソースが静的importの
  // 本構成では言語の切り替わりが画面にちらついて見えることはない。
  // レンダー中に changeLanguage すると、まだマウントされている前の言語のページに
  // 対して描画中に setState することになり、Reactが警告する。
  useLayoutEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    document.documentElement.lang = HTML_LANG[lang];
  }, [lang, i18n]);

  return (
    <>
      {!ownHeader && <Header />}
      <main style={{ marginTop: ownHeader ? 0 : '70px' }}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default LangLayout;
